import { Clock3, Sparkles } from "lucide-react";

const ComingSoon = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 p-6 overflow-hidden relative">
      {/* Background Blur */}
      <div className="absolute w-80 h-80 bg-blue-500/20 rounded-full blur-3xl top-10 left-10 animate-pulse"></div>
      <div className="absolute w-72 h-72 bg-purple-500/20 rounded-full blur-3xl bottom-10 right-10 animate-pulse"></div>

      {/* Card */}
      <div className="relative z-10 max-w-lg w-full">
        <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-10 shadow-2xl text-center">
          {/* Icon */}
          <div className="mx-auto w-24 h-24 rounded-full bg-gradient-to-r from-orange-500 to-red-500 flex items-center justify-center shadow-xl animate-bounce">
            <Clock3 className="w-12 h-12 text-white" />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 mt-6 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm text-blue-200">
            <Sparkles className="w-4 h-4" />
            Exciting Updates Coming
          </div>

          {/* Heading */}
          <h1 className="mt-6 text-5xl font-extrabold text-white tracking-wide">
            Coming Soon
          </h1>

          {/* Description */}
          <p className="mt-4 text-gray-300 leading-7">
            We're working hard to bring you something amazing.
            This feature is currently under development and will be
            available very soon.
          </p>

          {/* Divider */}
          <div className="w-20 h-1 bg-gradient-to-r from-orange-400 to-red-500 rounded-full mx-auto my-8"></div>

          {/* Status */}
          <div className="flex items-center justify-center gap-2 text-green-400 font-medium">
            <span className="w-3 h-3 bg-green-400 rounded-full animate-ping"></span>
            Development in Progress
          </div>

          {/* Footer */}
          <p className="mt-8 text-sm text-gray-400">
            🚀 Stay tuned for the next update!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;